// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import Vue from 'vue'
import App from './App'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import axiosPlugin, {
  baseURL
} from './server'
import {
  clearAllCookie
} from './util/utils'

import './assets/css/reset.css'
import './assets/css/public.css'
import './assets/css/el_entstyle.scss'
import './assets/css/utils.scss'
import {
  MessageBox,
  Message,
  Loading,
  Pagination
} from 'element-ui'

import echarts from 'echarts'
import china from 'echarts/map/json/china.json'

Object.defineProperties(Vue.prototype, {
  echarts: {
    get: () => echarts
  }
})

echarts.registerMap('china', china)

Vue.use(axiosPlugin)
Vue.use(Loading)
Vue.use(Pagination)

Vue.prototype.baseURL = baseURL

Vue.prototype.commonapi = '/commonapi'

Vue.prototype.action = 'https://upload-z2.qiniup.com' // 华南区

Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$message = Message

Vue.config.productionTip = false

// 退出登录
Vue.prototype.logout = function () {
  this.$confirm('是否确定退出登录', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    this.$http({
      method: 'GET',
      url: '/sys/logout'
    }).then(res => {
      if (res.code === 100) {
        clearAllCookie('pd_token')
        sessionStorage.clear()
        this.$router.replace({
          path: '/login'
        })
      }
    }).catch(error => {
      console.log(error)
      return false
    })
  }).catch(() => {
    this.$message({
      type: 'info',
      message: '已取消'
    });
  });
}

// 获取学校信息
Vue.prototype.getSchool = function (key, callback) {
  this.$http({
    method: 'post',
    url: '/common/searchSchools',
    params: {
      keyword: key
    }
  }).then(res => {
    callback(res.result)
  }).catch(error => {
    console.log(error)
    return false
  })
}
// 获取 导出信息
Vue.prototype.reqEexportStatus = function (key, loading) {
  window.setTimeout(() => {
    this.$http({
      method: 'post',
      url: '/demand/team/list/export/status',
      params: {
        pageType: key
      }
    }).then(res => {
      if (`${res.result}` === '0') {
        loading.close()
      } else {
        this.reqEexportStatus(key, loading)
      }
    }).catch(error => {
      console.log(error)
      return false
    })
  }, 2650)
}
// 获取 导出信息
Vue.prototype.getEexportStatus = function (key, callback) {
  const loading = this.$loading({
    lock: true,
    text: '处理中 ...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.35)'
  })
  this.reqEexportStatus(key, loading)
}

// 模糊搜索获取省市（key：省市名称或简称）
Vue.prototype.getProvince = function (key, callback) {
  this.$http({
    method: 'post',
    url: '/common/province',
    params: {
      key: key
    }
  }).then(res => {
    callback(res.result)
  }).catch(error => {
    console.log(error)
    return false
  })
}

// 获取用户信息
Vue.prototype.getUserinfo = function (callback) {
  this.$http({
    method: 'GET',
    url: '/sys/user/info'
  }).then(res => {
    if (res.code === 401) {
      this.$message.info(res.msg)
      this.$router.replace({
        path: '/login'
      })
      return false
    } else {
      Vue.prototype.userInfoness = res.user
      sessionStorage.setItem('userinfo', JSON.stringify(res.user))
      if (callback) {
        callback()
      }
    }
  }).catch((error) => {
    console.log(error)
    return false
  })
}

// 获取省市区三级联动数据
Vue.prototype.getAreainfo = function (callback) {
  // let areaList = JSON.parse(sessionStorage.getItem('areaListCache'))
  // if (areaList && areaList.length > 0) {
  //   callback(areaList)
  // } else {
    this.$http({
      method: 'POST',
      url: 'common/userArea'
    }).then(res => {
      if (res.code === 100) {
        callback(res.result)
        // sessionStorage.setItem('areaListCache', JSON.stringify(res.result))
      }
    }).catch((error) => {
      console.log(error)
      return false
    }) 
  // }
}

// 获取单位模糊搜索
Vue.prototype.getEnterprise = function (key, callback) {
  this.$http({
    method: 'post',
    url: '/data/query/enterprise/byname',
    params: {
      name: key
    }
  }).then(res => {
    if (res.code === 100) {
      callback(res.result)
    } else {
      let arr = []
      callback(arr)
    }
  }).catch(error => {
    console.log(error)
    return false
  })
}

const VUE_VERSION = require('../package.json').version
const current_version = window.localStorage.getItem('Version')
if (VUE_VERSION != current_version) {
  window.localStorage.clear()
  window.localStorage.setItem('Version', VUE_VERSION)
  location.reload()
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js